var _metadata, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKonoK(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 204.26799 187.26933",
    height: 187.26933,
    width: 204.26799,
    space: "preserve",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    cc: "http://creativecommons.org/ns#",
    dc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement(RDF, null, /*#__PURE__*/React.createElement(Work, {
    about: ""
  }, /*#__PURE__*/React.createElement("format", null, "image/svg+xml"), /*#__PURE__*/React.createElement("type", {
    resource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath20",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M 0,1200 H 2000 V 0 H 0 Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient92",
    spreadMethod: "pad",
    gradientTransform: "matrix(278.43967,0,0,-278.43967,857.99817,737.49115)",
    gradientUnits: "userSpaceOnUse",
    y2: 0,
    x2: 1,
    y1: 0,
    x1: 0
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop72",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop74",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop76",
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop78",
    offset: 0.04439189,
    style: {
      stopOpacity: 1,
      stopColor: "#ded9d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop80",
    offset: 0.264045,
    style: {
      stopOpacity: 1,
      stopColor: "#8b878d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop82",
    offset: 0.522472,
    style: {
      stopOpacity: 1,
      stopColor: "#f3f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop84",
    offset: 0.58197592,
    style: {
      stopOpacity: 1,
      stopColor: "#f3f4f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop86",
    offset: 0.876404,
    style: {
      stopOpacity: 1,
      stopColor: "#807b80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop88",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d1d3d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop90",
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#d1d3d4"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath102",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M 0,1200 H 2000 V 0 H 0 Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath114",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "m 857.99,610.623 h 30.912 V 585.4 H 857.99 Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath130",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "m 915.811,657.801 h 30.912 v -37.833 h -30.912 z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath146",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "m 952.282,681.898 h 37.531 v -33.637 h -37.531 z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath162",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "m 997.081,718.456 h 42.679 v -40.321 h -42.679 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,-716.28305,628.39572)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath20)",
    id: "g16"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(652.9353,330.8448)",
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#00062e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 0,0 -78.63,61.822 c -2.193,1.672 -3.573,3.313 -4.154,4.925 -0.58,1.609 -0.869,3.382 -0.869,5.314 0,2.187 0.386,4.119 1.158,5.794 0.775,1.673 2.447,3.479 5.023,5.412 l 74.379,57.185 H 34.58 L -57.38,71.867 37.478,0 Z m -115.723,140.452 h 24.535 V 0 h -24.535 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1396.1345,330.8448)",
    id: "g42"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1142.0121,561.0649)",
    id: "g56"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g60"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonoK);
export default __webpack_public_path__ + "static/media/kono-k.f20aaa91efee1f694d04bdd09fcb7f27.svg";
export { ForwardRef as ReactComponent };